import * as React from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { clearTabRoute } from "../services/tabShop";

async function logout() {
  try {
    const { status } = await axios.post("/api/auth/logout");
    return status === 200;
  } catch (err) {
    console.error(err);
    return false;
  }
}

export default function Logout() {
  const history = useHistory();

  React.useEffect(() => {
    localStorage.removeItem("uo");
    clearTabRoute();
    history.push("/");
    logout().then(() => {
      window.location.reload();
    });
  }, [history]);

  return null;
}
